<template>
  <span :class="classes">
    <slot></slot>
  </span>
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { Variant, Size } from "./types";

export interface PillProps {
  variant?: Variant;
  size?: Size;
  uppercase?: boolean;
}

const variants = {
  info: "tw-border-branding-blue-500 tw-text-branding-blue-500",
  warning: "tw-border-system-warning-500 tw-text-system-warning-500",
  danger: "tw-border-system-error-500 tw-text-system-error-500",
  success: "tw-border-system-success-500 tw-text-system-success-500",
  infoFull: "tw-border-branding-blue-600 tw-bg-branding-blue-600 tw-text-white",
  successFull:
    "tw-border-system-success-500 tw-bg-system-success-500 tw-text-white",
  darkFull: "tw-border-primary-grey-600 tw-bg-primary-grey-600 tw-text-white",
  none: "",
};

const sizes = {
  xs: "tw-text-xs tw-px-2",
  sm: "tw-text-sm tw-px-2 tw-py-1",
};

const props = withDefaults(defineProps<PillProps>(), {
  variant: "info",
  size: "xs",
  uppercase: true,
});

const classes = computed(() => {
  return [
    "tw-rounded-2xl tw-border tw-border-solid tw-font-semibold tw-inline-block",
    variants[props.variant],
    sizes[props.size],
    props.uppercase && "tw-uppercase",
  ];
});
</script>
